var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("categ_node_product", {
    attrs: { max_depth: 4, categories: _vm.categories },
    on: {
      set_active: _vm.set_active,
      set_active_default: _vm.set_active_default,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }